import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPaintRoller = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#787887"
      d="M14.25 2.25c.938 0 1.75.813 1.75 1.75v3c0 .969-.812 1.75-1.75 1.75H8a.246.246 0 0 0-.25.25v1H8c.531 0 1 .469 1 1v4c0 .563-.469 1-1 1H6c-.562 0-1-.437-1-1v-4c0-.531.438-1 1-1h.25V9c0-.937.781-1.75 1.75-1.75h6.25c.125 0 .25-.094.25-.25V4a.27.27 0 0 0-.25-.25H13v.75A1.5 1.5 0 0 1 11.5 6h-10A1.48 1.48 0 0 1 0 4.5v-3A1.5 1.5 0 0 1 1.5 0h10c.813 0 1.5.688 1.5 1.5v.75zM11.5 4.5v-3h-10v3zm-4 10v-3h-1v3z"
    />
  </svg>
);
export default SvgPaintRoller;
